export const WebhookEventTypes = [
	"event.created",
	"event.updated",
	"event.deleted",
	"event.rsvp.added",
	"event.rsvp.removed",
	"event.started",
	"event.ended",
	"poll.created",
	"poll.updated",
	"poll.deleted",
	"poll.option.added",
	"poll.vote.added",
	"poll.vote.removed",
	"poll.ended",
	"timefinder.created",
	"timefinder.updated",
	"timefinder.deleted",
	"timefinder.vote.added",
	"timefinder.vote.removed",
] as const;

export type WebhookEventType = (typeof WebhookEventTypes)[number];

export const WebhookEventTypeGroups = {
	Event: [
		"event.created",
		"event.updated",
		"event.deleted",
		"event.rsvp.added",
		"event.rsvp.removed",
		"event.started",
		"event.ended",
	],
	Poll: [
		"poll.created",
		"poll.updated",
		"poll.deleted",
		"poll.option.added",
		"poll.vote.added",
		"poll.vote.removed",
		"poll.ended",
	],
	TimeFinder: [
		"timefinder.created",
		"timefinder.updated",
		"timefinder.deleted",
		"timefinder.vote.added",
		"timefinder.vote.removed",
	],
} as const;

export interface WebhookPayload<T = unknown> {
	id: string;
	type: WebhookEventType;
	timestamp: string;
	guild_id: string;
	data: T;
}

export interface ApiErrorResponse {
	error: {
		code: string;
		message: string;
	};
}

export interface ApiPaginatedResponse<T> {
	data: T[];
	pagination: {
		total: number;
		limit: number;
		offset: number;
		has_more: boolean;
	};
}

// Rate limit headers
export interface RateLimitInfo {
	limit: number;
	remaining: number;
	reset: number;
}
